import { BACKEND_URL } from "../config";
import * as RestService from "./RestService";

const BASE_URL = BACKEND_URL + "/auth/payment";


export const tresxtresExcel = (startDate: string, endDate: string) => {
  return RestService.requestFile(`${BASE_URL}/organizer/me/3x3/excel?startDate=${startDate}&endDate=${endDate}`, 'excel', 'payments3x3.xlsx', '_blank')
}
